import React, { useEffect, useRef } from 'react';
import './cohorts-container.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Route, Routes, useNavigate } from 'react-router-dom';
import CohortList from './cohort-list.component';
import CohortCreateForm from './cohort-create-form.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import CohortUsers from './cohort-users.component';
import CohortMcs from './cohort-mcs.component';
import CohortView from '@/components/SHARED/cohort-view/cohort-view.component';
import CohortManageAdmin from './cohort-manage-admin.component';

const CohortsContainer = ({
    users,
    mcList,
    cohorts
}) => {

    const navigate = useNavigate();

    return (
        <div className='cohorts-container'>
            <Routes>
                <Route path='' element={
                    <div className='cohorts-landing-content'>
                        <div className='section-title with-icon'>
                            Manage Cohorts
                            <button
                                className='g-button'
                                title='Create New Cohort'
                                onClick={() => navigate('create')}>   
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                        </div>
                        <CohortList
                            cohorts={cohorts} />
                        
                    </div>
                }></Route>
                <Route path='create' element={
                    <div className='g-card'>
                        <CohortCreateForm
                            users={users}
                            mcList={mcList} />
                    </div>
                }></Route>
                <Route path='edit/:cohortPath' element={
                    <div className='g-card'>
                        <CohortCreateForm
                            users={users}
                            mcList={mcList}
                            cohorts={cohorts} />
                    </div>
                }></Route>
                <Route path='users/:cohortPath' element={
                    <div className='g-card'>
                        <CohortUsers
                            users={users}
                            cohorts={cohorts} />
                    </div>
                }></Route>
                <Route path='manageAdmin/:cohortPath' element={
                    <div className='g-card'>
                        <CohortManageAdmin
                            users={users}
                            cohorts={cohorts} />
                    </div>
                }></Route>
                <Route path='mcs/:cohortPath/*' element={
                    <div className='g-card'>
                        <CohortMcs
                            mcList={mcList}
                            cohorts={cohorts} />
                    </div>
                }></Route>
                <Route path='view/:cohortPath/*' element={
                    <div className='g-card'>
                        <CohortView />
                    </div>
                }></Route>
            </Routes>
            
        </div>
    )
}

export default CohortsContainer